import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    '&&': {
      boxShadow: '1px 1px 17px 4px rgba(63,172,168,0.35)',
      width: '48px',
      height: '48px',

      [theme.breakpoints.down('laptop')]: {
        position: 'fixed',
        bottom: 20,
        left: 20,
        zIndex: 99,
      },
      [theme.breakpoints.up('laptop')]: {
        display: 'none',
      },
    },
  },
}))
